// extracted by mini-css-extract-plugin
export var actionButton = "_ot-0";
export var actionMenuContainer = "_ot-i";
export var bubble = "_ot-2";
export var bubbleActionMenu = "_ot-j";
export var bubbleContext = "_ot-6";
export var bubbleItems = "_ot-7";
export var customer = "_ot-3";
export var divider = "_ot-8";
export var fileList = "_ot-9";
export var hiddenComment = "_ot-o";
export var infoAbove = "_ot-a";
export var internal = "_ot-4";
export var lightActionButton = "_ot-1";
export var link = "_ot-b";
export var merchant = "_ot-5";
export var message = "_ot-c";
export var profilePicture = "_ot-e";
export var quillToolbarContainer = "_ot-f";
export var senderDate = "_ot-g";
export var senderDateCustomer = "_ot-h";
export var senderName = "_ot-d";
export var time = "_ot-k";
export var uploadedImage = "_ot-l";
export var username = "_ot-m";
export var xsmall = "_ot-n";